import React from "react";
import ErrorScreen from "core/components/ErrorScreen";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";

export default function PlayerSizeError() {
  const { t } = useTranslation("player");

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 100000,
        backgroundColor: "#101010",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",

        ["@media (min-width: 200px) and (min-height: 140px)"]: {
          display: "none",
        },
      }}
    >
      <ErrorScreen
        icon={AspectRatioIcon}
        title={t("playerSizeError.title")}
        text={t("playerSizeError.text")}
      />
    </Box>
  );
}
